import React from "react";
import LabelAndCheckbox from "../../common/form/labelAndCheckbox";
import Grid from "../../common/layout/grid";
import { ModalAlert } from "../../common/dialog/modalAlert";

export function ModalFiltrosFaturasClienteAgua(props) {
    if (!props.visible) return null;

    function getStyleSlimCard(bgColor, textColor) {
        return {
            borderRadius: 8,
            cursor: "pointer",
            backgroundColor: bgColor,
            color: textColor || "#000000",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "10px 10px 0px 10px",
            width: "100%",
            minHeight: "40px",
            margin: 5,
            boxShadow: "#9b9b9b 0px 1px 2px 1px",
        };
    }

    return (
        <ModalAlert titulo="Filtrar Faturas" handleClose={props.handleClose}>
            <Grid cols={"12 12 12 12"}>
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        flexWrap: "wrap",
                        marginBottom: 20,
                        minHeight: "fit-content",
                    }}
                >
                    <Grid
                        cols={"12 12 6 6"}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                    >
                        <label style={getStyleSlimCard("#6dc9ff")} htmlFor="filtro-todas">
                            <LabelAndCheckbox
                                style={{ justifyContent: "center" }}
                                readOnly={props.aguardando}
                                modoCard={true}
                                colorIcon="#000"
                                id="filtro-todas"
                                label={`Mostrar todas (${props.quantidadesFiltro.qtdCorBranca + props.quantidadesFiltro.qtdCorAmarela + props.quantidadesFiltro.qtdCorAzul + props.quantidadesFiltro.qtdCorVerde + props.quantidadesFiltro.qtdCorVermelha})`}
                                onChange={(e) =>
                                    props.setState({
                                        ...props.filtroState,
                                        statusCorBranca: e.target.checked,
                                        statusCorAzul: e.target.checked,
                                        statusCorAmarela: e.target.checked,
                                        statusCorVermelha: e.target.checked,
                                        statusCorVerde: e.target.checked,
                                    })
                                }
                                value={
                                    props.filtroState.statusCorBranca &&
                                    props.filtroState.statusCorAzul &&
                                    props.filtroState.statusCorAmarela &&
                                    props.filtroState.statusCorVermelha &&
                                    props.filtroState.statusCorVerde
                                }
                            />
                        </label>
                    </Grid>
                    <Grid
                        cols={"12 12 6 6"}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                    >
                        <label style={getStyleSlimCard("rgb(255 239 113)")} htmlFor="filtro-amarelas">
                            <LabelAndCheckbox
                                style={{ justifyContent: "center" }}
                                readOnly={props.aguardando}
                                modoCard={true}
                                colorIcon="#000"
                                id="filtro-amarelas"
                                label={`Um ou dois dias para o vencimento (${props.quantidadesFiltro.qtdCorAmarela})`}
                                onChange={(e) =>
                                    props.setState({
                                        ...props.filtroState,
                                        statusCorAmarela: e.target.checked,
                                    })
                                }
                                value={props.filtroState.statusCorAmarela}
                            />
                        </label>
                    </Grid>

                    <Grid
                        cols={"12 12 6 6"}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                    >
                        <label style={getStyleSlimCard("rgb(255 101 105)")} htmlFor="filtro-vermelhas">
                            <LabelAndCheckbox
                                style={{ justifyContent: "center" }}
                                readOnly={props.aguardando}
                                modoCard={true}
                                colorIcon="#000"
                                id="filtro-vermelhas"
                                label={`Vencendo hoje ou vencida (${props.quantidadesFiltro.qtdCorVermelha})`}
                                onChange={(e) =>
                                    props.setState({
                                        ...props.filtroState,
                                        statusCorVermelha: e.target.checked,
                                    })
                                }
                                value={props.filtroState.statusCorVermelha}
                            />
                        </label>
                    </Grid>
                    <Grid
                        cols={"12 12 6 6"}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                    >
                        <label style={getStyleSlimCard("#44ffaa")} htmlFor="filtro-verdes">
                            <LabelAndCheckbox
                                style={{ justifyContent: "center" }}
                                readOnly={props.aguardando}
                                modoCard={true}
                                colorIcon="#000"
                                id="filtro-verdes"
                                label={`Paga (${props.quantidadesFiltro.qtdCorVerde})`}
                                onChange={(e) =>
                                    props.setState({
                                        ...props.filtroState,
                                        statusCorVerde: e.target.checked,
                                    })
                                }
                                value={props.filtroState.statusCorVerde}
                            />
                        </label>
                    </Grid>
                    <Grid
                        cols={"12 12 6 6"}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                    >
                        <label style={getStyleSlimCard("#f9f9f9")} htmlFor="filtro-brancas">
                            <LabelAndCheckbox
                                style={{ justifyContent: "center" }}
                                readOnly={props.aguardando}
                                modoCard={true}
                                colorIcon="#000"
                                id="filtro-brancas"
                                label={`Não importado (${props.quantidadesFiltro.qtdCorBranca})`}
                                onChange={(e) =>
                                    props.setState({
                                        ...props.filtroState,
                                        statusCorBranca: e.target.checked,
                                    })
                                }
                                value={props.filtroState.statusCorBranca}
                            />
                        </label>
                    </Grid>
                    <Grid
                        cols={"12 12 6 6"}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <label style={getStyleSlimCard("rgb(197 255 255)")} htmlFor="filtro-azuis">
                            <LabelAndCheckbox
                                style={{ justifyContent: "center" }}
                                readOnly={props.aguardando}
                                modoCard={true}
                                colorIcon="#000"
                                id="filtro-azuis"
                                label={`Importada e não vencida (${props.quantidadesFiltro.qtdCorAzul})`}
                                onChange={(e) =>
                                    props.setState({
                                        ...props.filtroState,
                                        statusCorAzul: e.target.checked,
                                    })
                                }
                                value={props.filtroState.statusCorAzul}
                            />
                        </label>
                    </Grid>
                </div>
            </Grid>
        </ModalAlert>
    );
}
